import React from "react";

import { StatusBadgeProps } from "./statusBadgeProps";

export const CreditedStatusBadge = (props: StatusBadgeProps) => {
    const { width, height = "20", viewBox = "0 0 68.7 18", ...rest } = props;

    return (
        <svg
            width={width}
            height={height}
            // viewBox="0 0 53 20"
            fill="none"
            // xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="53" height="20" rx={3} fill="#FF991F" />
            <path
                d="M10.4305 14.1495C12.1095 14.1495 13.363 13.333 13.9495 11.815L12.788 11.378C12.4085 12.436 11.592 12.9765 10.4305 12.9765C8.80905 12.9765 7.85455 11.8955 7.85455 9.975C7.85455 8.066 8.80905 6.9965 10.4535 6.9965C11.6035 6.9965 12.4085 7.514 12.788 8.5605L13.9265 8.1235C13.34 6.617 12.121 5.8235 10.4535 5.8235C8.10755 5.8235 6.62405 7.4105 6.62405 9.9865C6.62405 12.551 8.09605 14.1495 10.4305 14.1495ZM21.2612 14L19.0877 10.4465C20.0882 10.1475 20.6287 9.4 20.6287 8.2615C20.6287 6.824 19.7777 5.9845 17.9262 5.9845H15.4192V14H16.6382V10.596H17.3627H17.8687L19.8237 14H21.2612ZM16.6382 9.469V7.123H17.7997C18.8462 7.123 19.3867 7.4335 19.3867 8.2845C19.3867 9.1355 18.8462 9.469 17.7997 9.469H16.6382ZM22.6179 14H27.9194V12.8615H23.8484V10.458H27.5859V9.3195H23.8484V7.123H27.9194V5.9845H22.6179V14ZM29.7156 14H31.9696C34.6721 14 36.1326 12.6085 36.1326 10.0555C36.1326 7.4565 34.6261 5.9845 31.9811 5.9845H29.7156V14ZM30.9461 12.8615V7.123H31.9696C33.9591 7.123 34.8906 8.043 34.8906 10.0095C34.8906 11.9875 33.9591 12.8615 31.8546 12.8615H30.9461ZM37.7903 14H39.0208V5.9845H37.7903V14ZM42.9056 14H44.1476V7.123H46.7466V5.9845H40.3181V7.123H42.9056V14Z"
                fill="#FDF4E7"
            />
        </svg>
    );
};
